export default (): boolean => {
    let check: boolean = false;
    ((a) => {
        if (/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(a)) check = true;
    })(navigator.userAgent.toLowerCase());
    return check;
};